import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";
const Home = () => import("@/views/home/home/home.vue");
import Login from "../views/login/login.vue";
import blankPage from "../views/public-page/blank-page/blank-page.vue";
import i18n from "@/config/i18n";
const importError = () => import("@/views/public-page/import-error/import-error.vue");
const accountInfo = () => import("@/views/public-page/account-info/account-info.vue");
Vue.use(VueRouter);
const routes = [
    {
        path: "/",
        name: "主页",
        component: Home,
    },
    {
        path: "/public-page/import-error",
        name: i18n.t("childMenuTitle.importError") + "",
        component: importError,
    },
    {
        path: "/account/info",
        name: i18n.t("childMenuTitle.accInfo") + "",
        component: accountInfo,
    },
    {
        path: "/blank-page",
        name: "blank",
        component: blankPage,
    },
    {
        path: "/login",
        name: i18n.t("childMenuTitle.login") + "",
        component: Login,
        meta: {
            full: true,
            isLogin: false,
        },
    },
    {
        path: "/login/reset-password",
        name: "忘记密码",
        component: () => import("@/views/login/children/login-reset-password/login-reset-password.vue"),
        meta: {
            isLogin: false,
        },
    },
    {
        path: "/login/register/account-register",
        name: "注册-运营商注册",
        component: () => import("@/views/login/children/register-account-register/register-account-register.vue"),
        meta: {
            isLogin: false,
        },
    },
    {
        path: "/login/register/account-register/success",
        name: "注册-运营商注册成功",
        component: () => import("@/views/login/children/register-account-register-success/register-account-register-success.vue"),
        meta: {
            isLogin: false,
        },
    },
];
const router = new VueRouter({
    // mode: "history",
    base: process.env.BASE_URL,
    routes,
});
let timerPage;
router.beforeEach((to, from, next) => {
    const state = store.state; // eslint-disable-line
    clearTimeout(timerPage);
    timerPage = setTimeout(() => {
        store.commit("SET_PAGELOADING", true);
    }, 100);
    if (!state.sys.isGetRouter) {
        //如果还没有添加路由 并且 是须要登录的页面
        if (isLoginFunction(to)) {
            store.dispatch("getRouter", {
                next: next,
                to: to,
            });
        }
        else {
            // 不须要登录的页面：比如注册流程
            next();
        }
    }
    else {
        // 已经登录
        next();
    }
});
router.afterEach(() => {
    // 动态加载路由页面时给个动画，有时候网不好要几秒钟
    clearTimeout(timerPage);
    store.commit("SET_PAGELOADING", false);
});
/**
 *
 * @param to 判断页面是否须要登录
 * @returns
 */
const isLoginFunction = function (to) {
    let isLogin = true;
    if (to.meta && to.meta.isLogin === false) {
        isLogin = false;
    }
    return isLogin;
};
export default router;
